import * as Business   from '../../business';
import * as UI         from '../../ui';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import { Fragment }    from 'react';
import { useCallback } from 'react';
import ChoosePageView  from './choose_page_view';
import CurrentPageView from './current_page_view';
import FetchFromServer from '../../components/fetch_from_server';
import Navbar          from '../../components/navbar';
import React           from 'react';


export default connect(
  (state, { businessID }) => ({
    statuses:     Business.getBusinessStatuses(state, businessID),
    business:     Business.getBusiness(state, businessID),
    facebookPage: Business.getFacebookPage(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:                   compose(dispatch, Business.loadBusiness, () => (businessID)),
    saveFacebookPage:       compose(dispatch, Business.saveFacebookPage, ({ pageID, accessToken }) => ({ businessID, pageID, accessToken })),
    disconnectFacebookPage: compose(dispatch, Business.disconnectFacebookPage, () => (businessID)),
    progressStart:          () => dispatch(UI.progressStart()),
    progressEnd:            () => dispatch(UI.progressEnd())
  })
)(FacebookPage);


export function FacebookPage({
  business,
  statuses,
  load,
  facebookPage,
  saveFacebookPage,
  disconnectFacebookPage,
  navigateBackTo,
  progressStart,
  progressEnd
}) {

  const { readStatus } = statuses;
  const isReady        = readStatus.succeeded;
  const pageID         = business?.facebook?.pageID;
  const facebookStatus = business?.facebook?.status;
  const isConnected    = pageID && facebookStatus;

  const disconnect = useCallback(() => {
    disconnectFacebookPage();
    navigateBackTo('../');
  }, [ disconnectFacebookPage, navigateBackTo ]);

  return (
    <Fragment>
      <Navbar title="Facebook"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile facebook">

        {isReady && isConnected &&
          <CurrentPageView {...{
            facebookPage,
            facebookStatus,
            disconnect
          }}/>
        }

        {isReady && !isConnected &&
          <ChoosePageView {...{
            business,
            statuses,
            saveFacebookPage,
            navigateBackTo,
            progressStart,
            progressEnd
          }}/>
        }

      </FetchFromServer>
    </Fragment>
  );
}
